// This is being used for the imports drawer in salary calculations
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawerContainer", "drawer", "backdrop", "container"]

  connect() {
    // Add escape key listener
    document.addEventListener('keydown', this.handleKeyDown.bind(this))
    
    // Prevent body scrolling when drawer is open
    if (this.isOpen()) {
      document.body.style.overflow = 'hidden'
    }
  }
  
  disconnect() {
    // Remove escape key listener
    document.removeEventListener('keydown', this.handleKeyDown.bind(this))
    
    // Restore body scrolling
    document.body.style.overflow = ''
  }

  open(event) {
    event.preventDefault()
    const el = event.currentTarget
    
    // Find the specific drawer container based on frame ID
    const frameId = el.dataset.drawerFrameId || "imports_drawer_content"
    const drawerContainer = this.element.querySelector(`[data-drawer-container-for="${frameId}"]`)
    
    if (!drawerContainer) {
      console.error(`Drawer container not found for frame ID: ${frameId}`)
      return
    }
    
    const drawer = drawerContainer.querySelector('[data-drawer-target="drawer"]')
    const backdrop = drawerContainer.querySelector('[data-drawer-target="backdrop"]')
    const container = drawerContainer.querySelector('[data-drawer-target="container"]')
    
    // Show the drawer container
    drawerContainer.style.display = 'block'
    
    // Prevent body scrolling immediately
    document.body.style.overflow = 'hidden'
    
    // Load content via Turbo Frame if URL is provided (do this first)
    const url = el.dataset.drawerUrl
    if (url && container) {
      // Destroy and recreate the turbo frame
      const oldFrame = container.querySelector('turbo-frame')
      if (oldFrame) {
        oldFrame.remove()
      }
      
      // Create new turbo frame
      const newFrame = document.createElement("turbo-frame")
      newFrame.id = frameId
      newFrame.innerHTML = '<div class="p-6">Loading...</div>'
      
      container.appendChild(newFrame)
      
      // Set src to trigger request
      newFrame.setAttribute("src", url)
    }
    
    // Add a small delay before showing backdrop and drawer for smoother animation
    setTimeout(() => {
      // Show backdrop and drawer
      if (backdrop) {
        backdrop.classList.remove("hidden")
      }
      if (drawer) {
        drawer.classList.remove("translate-x-full")
        drawer.classList.add("translate-x-0")
      }
    }, 50)
  }

  close() {
    // Find all open drawers and close them
    const openDrawers = this.element.querySelectorAll('[data-drawer-target="drawerContainer"][style*="block"]')
    
    openDrawers.forEach((drawerContainer) => {
      const drawer = drawerContainer.querySelector('[data-drawer-target="drawer"]')
      const backdrop = drawerContainer.querySelector('[data-drawer-target="backdrop"]')
      
      // Hide drawer and backdrop
      if (drawer) {
        drawer.classList.remove("translate-x-0")
        drawer.classList.add("translate-x-full")
      }
      if (backdrop) {
        backdrop.classList.add("hidden")
      }
      
      // Hide the drawer container after animation
      setTimeout(() => {
        drawerContainer.style.display = 'none'
      }, 300)
    })
    
    // Restore body scrolling
    document.body.style.overflow = ''
  }

  toggle() {
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  isOpen() {
    const openDrawers = this.element.querySelectorAll('[data-drawer-target="drawerContainer"][style*="block"]')
    return openDrawers.length > 0
  }
  
  handleKeyDown(event) {
    if (event.key === 'Escape' && this.isOpen()) {
      this.close()
    }
  }

  backdropClick(event) {
    // Close drawer when clicking on backdrop
    const backdrop = event.target.closest('[data-drawer-target="backdrop"]')
    if (backdrop) {
      this.close()
    }
  }
}

